module.exports = __webpack_public_path__ + "img/sugarfree.fd94ad2e.svg";